module.exports = "/images/pin-arch.png?42e67662db704b57c9c6692f38fd517f";